var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"alert-animated"},[_c('button',{staticClass:"btn btn-outline-success",on:{"click":_vm.showAlert}},[_vm._v("Click here!")])])
}
var staticRenderFns = []

export { render, staticRenderFns }